import { Card, Col, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import SelectedNumbersTable from '@components/Order/Numbers/SelectNumbers/SelectedNumbersTable';
import { BackorderNumbersTable } from '@components/Order/Numbers/Tables';
import { Page500 } from '@containers/ErrorPages';
import { cartApi } from '@reducers/order';
import { planDetailsApi } from '@reducers/plan/plan';
import { skipToken } from '@reduxjs/toolkit/query';

const UnavailableBackorders = () => (
  <Card>
    <Card.Header className="bg-didxl text-white" />
    <Card.Body>
      <p>
        Unfortunately, we cannot order additional DIDs for this Plan. You can
        order the selected DIDs by pressing Continue.
      </p>
      <p>If you need more DIDs in this Country, please check our other Plans</p>
    </Card.Body>
  </Card>
);

export const SelectBackorders = () => {
  const { id, type, prefixID } = useParams();
  let amountAvailable = null;
  const queryArg = id && prefixID ? { id, type, prefixID } : skipToken;
  const backorderInfo = planDetailsApi.useGetBackordersInfoQuery(queryArg);
  const backorderCart = cartApi.useGetBackordersForPlanQuery(queryArg);

  const isLoading =
    backorderInfo.isLoading ||
    backorderInfo.isFetching ||
    backorderCart.isLoading ||
    backorderCart.isFetching;
  const isError = backorderInfo.isError || backorderCart.isError;

  if (isLoading) {
    return <DefaultSpinnerCenter />;
  }
  if (isError) {
    return <Page500 />;
  }
  if (backorderInfo.data.length !== 0) {
    amountAvailable = backorderInfo.data[0].stock;
  }
  return (
    <Row>
      <Col md={9}>
        {amountAvailable === 0 ? (
          <UnavailableBackorders />
        ) : (
          <BackorderNumbersTable
            data={backorderInfo.data}
            cartData={backorderCart.data}
          />
        )}
      </Col>
      <Col md={3}>
        <SelectedNumbersTable
          useData={cartApi.useGetForPlanQuery}
          useDataArgs={queryArg}
          header="Pending DIDs for this plan"
          backorder
        />
      </Col>
    </Row>
  );
};
